export default "assets/logo_cpf-87cf0c28.png";